export const MAX_DISPLAYED_RESULTS = 4
export const MAX_DISPLAYED_RESULTS_SEARCH_PAGE = 15
export const DEBOUNCED_TIME = 600
export const QUERY_MIN_LENGTH = 1
